import React, { useState, useContext, useEffect } from "react";

import {
  InputCopy,
  FormGroup,
  Select,
  Tooltip,
  StatusDot,
  Checkbox,
  Subheader,
  Button,
  Head,
  Card,
  Input,
  RadioGroup,
  Switch,
  Icon,
  ButtonAction,
  Tag,
  Notification
} from "xsolla-uikit";

export function PAloginSBwidget({ editmode = true, children }) {
  const [state, setState] = useState((editmode = editmode));

  return (
    <div className="l_sb0">
      {children}
      {editmode && (
        <div className="x_left0">
          <div className="x_left0_sticky">
            <div className="xx_set_head xx_set_head--main">
              <FormGroup indentation="xs">
                <Head appearance="separated" indentation="lg">
                  Login Widget
                </Head>
              </FormGroup>
            </div>
            <div
              data-xsb-settings-module="onoff"
              data-xsb-settings-module-onoff-activetarget="w_buy"
              className="xx_set_sect"
            >
              <div className="xsb_set_line xsb_set_line--fullsub xsb_set_line--login">
                <div className="l_width100">
                  <div className="xsb_sett_toggle0">
                    <div className="xsb_sett_toggle_b">
                      <div className="xsb_sett_toggle_t" />
                    </div>
                    <div
                      data-xsb-settings-module-onoff="hero_w_logo"
                      className="xsb_sett_toggle_label"
                    >
                      <div>Logo image</div>
                    </div>
                  </div>
                  <div className="xsb_module_but">
                    <div className="xsb_global_settings_bg xsb_global_settings_bg--2">
                      <div
                        xsb_template_media_control="bg"
                        className="xsb_media"
                      >
                        <div className="xsb_but_upload">
                          <div className="w-embed">
                            <svg
                              width={24}
                              height={24}
                              viewBox="0 0 24 24"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                fillRule="evenodd"
                                clipRule="evenodd"
                                d="M7.5 19C4.46243 19 2 16.5376 2 13.5C2 10.4624 4.46243 8 7.5 8C7.60002 8 7.69941 8.00267 7.79811 8.00794C8.8344 6.21016 10.7759 5 13 5C16.0561 5 18.5785 7.28485 18.9523 10.2395C20.7249 10.8436 22 12.5229 22 14.5C22 16.9853 19.9853 19 17.5 19H14V17.3852H17.9237C19.4108 17.3852 20.6163 16.1797 20.6163 14.6926C20.6163 13.5312 19.874 12.5112 18.793 12.1428C18.0138 11.8773 17.4541 11.1909 17.3508 10.3742C17.0806 8.23775 15.2526 6.61481 13.077 6.61481C11.5177 6.61481 10.106 7.44842 9.34063 8.77615C8.93545 9.47906 8.16968 9.89468 7.35951 9.85141C7.29113 9.84776 7.22239 9.84592 7.15332 9.84592C5.07141 9.84592 3.38369 11.5336 3.38369 13.6156C3.38369 15.6975 5.07141 17.3852 7.15332 17.3852H10V19H7.5ZM8 14L12 10L16 14H13V19C13 19.5523 12.5523 20 12 20C11.4477 20 11 19.5523 11 19V14H8Z"
                                fill="currentColor"
                              />
                            </svg>
                          </div>
                        </div>
                        <div className="xccz">
                          <div className="x_contentimage">
                            <div className="x_temp_pic1 x_temp_pic--2" />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              data-xsb-settings-module="onoff"
              data-xsb-settings-module-onoff-activetarget="w_buy"
              className="xx_set_sect"
            >
              <div className="xx_set_head">
                <div className="xx_img_menu_left">
                  <div data-xsb-settings-module-onoff="w_pack1">
                    <div className="xsb_sett_head">Big social</div>
                  </div>
                </div>
                <div className="xx_img_menu_right">
                  <div className="xx_img_menu_li">
                    <div className="xx_but_menu_icon xx_but_menu_icon--secondary">
                      <div>delete</div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="xx_set_menu xx_set_menu--noborder" />
              <div className="xsb_set_line xsb_set_line--fullsub">
                <div className="xx_set_line" />
                <div className="xx_set_line">
                  <div className="xsb_but_link_input">
                    <div className="social_icon social_icon--sett w-embed">
                      <svg
                        fill="none"
                        height={24}
                        viewBox="0 0 24 24"
                        width={24}
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          clipRule="evenodd"
                          d="m13.5044 13.3199h2.9356l.4411-3.36812h-3.3778v-2.15854c0-.97857.2667-1.64518 1.6856-1.64518h1.8111v-3.02218c-.3133-.0416-1.3889-.12588-2.6389-.12588-2.6111 0-4.39666 1.56746-4.39666 4.45829v2.49349h-2.96444v3.36812h2.96444v8.6801h3.53996z"
                          fill="currentColor"
                          fillRule="evenodd"
                        />
                      </svg>
                    </div>
                    <div className="xsb_but_seturl_placeholder">
                      <div className="text-block-19">Facebook</div>
                    </div>
                    <div className="xx_but_menu_icon xx_but_sett_icon--blue">
                      <div>expand_more</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              data-xsb-settings-module="onoff"
              data-xsb-settings-module-onoff-activetarget="w_buy"
              className="xx_set_sect"
            >
              <div className="xx_set_head">
                <div className="xx_img_menu_left">
                  <div data-xsb-settings-module-onoff="w_pack1">
                    <div className="xsb_sett_head">Password</div>
                  </div>
                </div>
                <div className="xx_img_menu_right">
                  <div className="xx_img_menu_li" />
                </div>
              </div>
              <div className="xx_set_menu xx_set_menu--noborder" />
              <div className="xsb_set_line xsb_set_line--fullsub xsb_set_line--login">
                <div className="xx_set_line">
                  <div className="xx_set_line">
                    <div className="xsb_sett_label">Security:</div>
                    <div className="xsb_but_link_input">
                      <div className="xsb_but_seturl_placeholder">
                        <div className="text-block-19">
                          Standard (min 8, case, numbers)
                        </div>
                      </div>
                      <div className="xx_but_menu_icon xx_but_sett_icon--blue">
                        <div>expand_more</div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="xx_set_line">
                  <div className="xsb_sett_toggle0">
                    <div className="xsb_sett_toggle_b">
                      <div className="xsb_sett_toggle_t" />
                    </div>
                    <div
                      data-xsb-settings-module-onoff="hero_w_logo"
                      className="xsb_sett_toggle_label"
                    >
                      <div>Enter pasword twice on registration</div>
                    </div>
                  </div>
                </div>
                <div className="xx_set_line">
                  <div className="xsb_sett_toggle0">
                    <div className="xsb_sett_toggle_b">
                      <div className="xsb_sett_toggle_t" />
                    </div>
                    <div
                      data-xsb-settings-module-onoff="hero_w_logo"
                      className="xsb_sett_toggle_label"
                    >
                      <div>"Eye"</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              data-xsb-settings-module="onoff"
              data-xsb-settings-module-onoff-activetarget="w_buy"
              className="xx_set_sect"
            >
              <div className="xx_set_head">
                <div className="xx_img_menu_left">
                  <div data-xsb-settings-module-onoff="w_pack1">
                    <div className="xsb_sett_head">Footer social</div>
                  </div>
                </div>
                <div className="xx_img_menu_right">
                  <div className="xx_img_menu_li">
                    <div className="xx_but_menu_icon xx_but_menu_icon--secondary">
                      <div>delete</div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="xx_set_menu xx_set_menu--noborder" />
              <div className="xsb_set_line xsb_set_line--fullsub">
                <div className="xx_set_line" />
                <div className="xx_set_line">
                  <div className="x_flex x_flex--vcenter">
                    <div className="xsb_sett_drag" />
                    <div className="xsb_but_link_input">
                      <div className="social_icon social_icon--sett w-embed">
                        <svg
                          fill="none"
                          height={24}
                          viewBox="0 0 24 24"
                          width={24}
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            clipRule="evenodd"
                            d="m13.5044 13.3199h2.9356l.4411-3.36812h-3.3778v-2.15854c0-.97857.2667-1.64518 1.6856-1.64518h1.8111v-3.02218c-.3133-.0416-1.3889-.12588-2.6389-.12588-2.6111 0-4.39666 1.56746-4.39666 4.45829v2.49349h-2.96444v3.36812h2.96444v8.6801h3.53996z"
                            fill="currentColor"
                            fillRule="evenodd"
                          />
                        </svg>
                      </div>
                      <div className="xsb_but_seturl_placeholder">
                        <div>Facebook</div>
                      </div>
                      <div className="xx_but_menu_icon xx_but_sett_icon--blue">
                        <div>expand_more</div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="xx_set_line">
                  <div className="x_flex x_flex--vcenter">
                    <div className="xsb_sett_drag" />
                    <div className="xsb_but_link_input">
                      <div className="social_icon social_icon--sett w-embed">
                        <svg
                          width={24}
                          height={24}
                          viewBox="0 0 24 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M9.18374 3.49242C6.93651 4.25353 5.07148 5.85373 3.9795 7.95768C3.61066 8.6722 3.34162 9.43383 3.17989 10.2213C2.77617 12.1952 3.05655 14.2474 3.97499 16.0412C4.57897 17.2106 5.4293 18.2356 6.46755 19.0458C7.45634 19.817 8.59236 20.3785 9.80603 20.6959C11.3364 21.0974 12.9649 21.0884 14.5054 20.7444C15.898 20.4297 17.216 19.7767 18.2686 18.8281C19.3717 17.8196 20.1761 16.5278 20.594 15.0937C21.0525 13.5497 21.1124 11.9007 20.8255 10.3138H12.1857V13.826H17.1923C17.0903 14.3896 16.8749 14.9268 16.5591 15.4048C16.2432 15.8829 15.8335 16.292 15.3547 16.6073C14.7412 17.0048 14.0523 17.2716 13.3309 17.3912C12.6057 17.5204 11.8633 17.5188 11.1387 17.3867C10.4054 17.24 9.70974 16.9453 9.09452 16.5205C8.11699 15.8463 7.3803 14.8783 6.99159 13.7572C6.60082 12.6305 6.5963 11.3774 6.99159 10.2552C7.26958 9.45583 7.7252 8.72975 8.32427 8.13137C9.07423 7.37748 10.0279 6.85817 11.0687 6.63694C11.9628 6.45135 12.8889 6.48776 13.7657 6.74296C14.5054 6.96063 15.1876 7.36329 15.7455 7.88436L17.4339 6.22977C17.7298 5.9354 18.0404 5.65004 18.3273 5.34439C17.467 4.56086 16.4624 3.95179 15.3694 3.55107C13.3727 2.83796 11.1937 2.8173 9.18374 3.49242V3.49242Z"
                            fill="currentColor"
                          />
                          <path
                            d="M9.18388 3.49259C11.1936 2.8181 13.3718 2.83677 15.3696 3.5456C16.4651 3.94148 17.468 4.56068 18.3274 5.34005C18.0406 5.64457 17.73 5.92992 17.4341 6.22543L15.7456 7.88002C15.182 7.35251 14.5041 6.96191 13.7647 6.73861C12.8888 6.48087 11.9625 6.44405 11.0688 6.63146C10.1357 6.83536 9.27064 7.2753 8.5567 7.90909C7.84276 8.54287 7.30387 9.34923 6.99173 10.2508C5.9877 9.48611 4.98593 8.72705 3.97852 7.96235C5.0691 5.85589 6.93496 4.2537 9.18388 3.49259V3.49259Z"
                            fill="currentColor"
                          />
                          <path
                            d="M3.18405 10.2172C3.34781 9.43329 3.61322 8.66859 3.98479 7.95239C4.98656 8.71709 5.98833 9.47728 6.99575 10.242C6.60046 11.3687 6.60046 12.6218 6.99575 13.744C5.99398 14.5087 4.99108 15.2734 3.98931 16.0325C3.06258 14.2431 2.77836 12.1905 3.18405 10.2172V10.2172Z"
                            fill="currentColor"
                          />
                          <path
                            d="M12.1853 10.3096H20.8252C21.1193 11.8993 21.04 13.5355 20.5937 15.0895C20.1754 16.5237 19.3706 17.8155 18.2671 18.8239L15.3499 16.6031C15.8285 16.2877 16.238 15.8785 16.5536 15.4005C16.8693 14.9224 17.0845 14.3853 17.1863 13.8218H12.1797C12.1853 12.651 12.1853 11.4803 12.1853 10.3096Z"
                            fill="currentColor"
                          />
                          <path
                            d="M3.97949 16.037C4.98239 15.2779 5.98416 14.5144 6.98593 13.7485C7.37669 14.8688 8.11341 15.8364 9.08999 16.5118C9.70212 16.9325 10.4035 17.2325 11.1342 17.378C11.8547 17.5224 12.6001 17.5032 13.3252 17.3825C14.047 17.2631 14.7364 16.9963 15.3502 16.5987L18.2686 18.8195C17.216 19.7725 15.898 20.421 14.5054 20.7346C12.9649 21.0786 11.3364 21.0887 9.80602 20.6872C8.59159 20.3718 7.45517 19.8102 6.46754 19.0371C5.43099 18.2282 4.58217 17.2047 3.97949 16.037V16.037Z"
                            fill="currentColor"
                          />
                        </svg>
                      </div>
                      <div className="xsb_but_seturl_placeholder">
                        <div className="text-block-19">Google</div>
                      </div>
                      <div className="xx_but_menu_icon xx_but_sett_icon--blue">
                        <div>expand_more</div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="xx_set_line">
                  <div className="x_flex x_flex--vcenter">
                    <div className="xsb_sett_drag" />
                    <div className="xsb_but_link_input">
                      <div className="social_icon social_icon--sett w-embed">
                        <svg
                          fill="none"
                          height={24}
                          viewBox="0 0 24 24"
                          width={24}
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <g
                            clipRule="evenodd"
                            fill="currentColor"
                            fillRule="evenodd"
                          >
                            <path d="m11.9844 3c-4.73586 0-8.61571 3.64539-8.9844 8.2781l4.83212 1.9944c.40941-.2795.90403-.4429 1.43621-.4429.04764 0 .09509.0012.14214.004l2.14903-3.1094c0-.0148-.0003-.02921-.0003-.04401 0-1.87144 1.5251-3.39417 3.4-3.39417 1.8747 0 3.4001 1.52273 3.4001 3.39417 0 1.87161-1.5254 3.39441-3.4001 3.39441-.0259 0-.0514-.0006-.0771-.0012l-3.0648 2.183c.0016.0399.003.0803.003.1206 0 1.4049-1.1448 2.5477-2.55197 2.5477-1.23536 0-2.26809-.8803-2.50215-2.0458l-3.45581-1.4263c1.07009 3.7778 4.54686 6.5474 8.67403 6.5474 4.9792 0 9.0156-4.0296 9.0156-9 0-4.97057-4.0364-9-9.0156-9z" />
                            <path d="m8.65042 16.6563-1.10745-.4567c.1963.4079.53593.7493.98667.937.97441.4053 2.09806-.0564 2.50436-1.0298.1965-.4712.1978-.9908.0029-1.4629-.1947-.4722-.5622-.8405-1.0343-1.037-.4685-.1946-.97044-.1873-1.41148-.0214l1.14402.4723c.71876.2992 1.05866 1.1231.75916 1.8406-.2993.7176-1.12508 1.057-1.84388.7579z" />
                            <path d="m13.2607 9.6763c0-.93838.7621-1.69876 1.7019-1.69876.94 0 1.7019.76038 1.7019 1.69876 0 .9384-.7619 1.6988-1.7019 1.6988-.9398 0-1.7019-.7604-1.7019-1.6988zm3.9637.00395c0-1.24704-1.0163-2.26179-2.2655-2.26179s-2.2655 1.01475-2.2655 2.26179c0 1.24705 1.0163 2.26135 2.2655 2.26135s2.2655-1.0143 2.2655-2.26135z" />
                          </g>
                        </svg>
                      </div>
                      <div className="xsb_but_seturl_placeholder">
                        <div className="text-block-19">Steam</div>
                      </div>
                      <div className="xx_but_menu_icon xx_but_sett_icon--blue">
                        <div>expand_more</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      <div className="x_right0">
        <div className="xsb_cont_tabs">
          <div className="x_flex x_flex--center x_flex--vcenter">
            <div className="p_button p_button--appearance-flatten">
              <div>Login</div>
            </div>
            <div className="p_x_card_filter_div" />
            <div className="p_button p_button--appearance-flatten inactive">
              <div>sign up</div>
            </div>
          </div>
        </div>
        <div className="x_paddings">
          <div className="x_flex x_flex--center">
            <div className="login_block">
              <div className="login_body login_body--shadow">
                <div className="login_body0">
                  <div className="x_login_logo">
                    <div className="xccz">
                      <div className="x_contentimage">
                        <div className="x_contentimage_static">
                          <div className="x_temp_pic1 x_temp_pic--2" />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="tab">
                    <div className="tab_input active">
                      <div>login</div>
                    </div>
                    <div className="tab_input">
                      <div>sign up</div>
                    </div>
                  </div>
                  <div className="login_section">
                    <div className="button_primary social">
                      <div className="button_icon" />
                      <div className="text_button">LOGIN WITH facebook</div>
                    </div>
                  </div>
                  <div className="login_section">
                    <div className="divider" />
                  </div>
                  <div className="login_section">
                    <div className="input_block">
                      <div className="input focused">
                        <div className="x_login_placeholder">Email</div>
                      </div>
                      <div className="error_message hide">
                        This is some text inside of a div block.
                      </div>
                    </div>
                    <div className="input_block">
                      <div className="input">
                        <div className="x_login_placeholder">Password</div>
                        <div className="input_icon">
                          <div className="x0_current_more">
                            <div>remove_red_eye</div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="button_primary _12">
                      <div className="text_button _90">login</div>
                    </div>
                  </div>
                  <div className="login_section">
                    <div className="text_link_block">
                      <a href="#" className="text_link">
                        Forgot password?
                      </a>
                    </div>
                  </div>
                  <div className="login_section">
                    <div className="social_block">
                      <div className="social_icon w-embed">
                        <svg
                          fill="none"
                          height={24}
                          viewBox="0 0 24 24"
                          width={24}
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <g fill="currentColor">
                            <path d="m9.79801 10.0405c-.55836 0-.99918.4792-.99918 1.0638s.45061 1.0637.99918 1.0637c.55839 0 .99919-.4791.99919-1.0637.0098-.5846-.4408-1.0638-.99919-1.0638zm3.57549 0c-.5583 0-.9992.4792-.9992 1.0638s.4507 1.0637.9992 1.0637c.5584 0 .9992-.4791.9992-1.0637s-.4408-1.0638-.9992-1.0638z" />
                            <path d="m18.0086 2h-13.01717c-1.09772 0-1.99143.874-1.99143 1.957v12.844c0 1.083.89371 1.957 1.99143 1.957h11.01597l-.5148-1.7575 1.2434 1.1305 1.1754 1.064 2.0886 1.805v-17.043c0-1.083-.8937-1.957-1.9914-1.957zm-3.7497 12.407s-.3498-.4085-.6412-.7695c1.2726-.3515 1.7583-1.1305 1.7583-1.1305-.3983.2565-.7771.437-1.1171.5605-.4858.1995-.952.3325-1.4086.4085-.9326.171-1.7874.1235-2.516-.0095-.55373-.1045-1.02973-.2565-1.42801-.4085-.22343-.0855-.46629-.19-.70915-.323-.02914-.019-.05828-.0285-.08743-.0475-.01942-.0095-.02914-.019-.03885-.0285-.17486-.095-.272-.1615-.272-.1615s.46628.76 1.7 1.121c-.29143.361-.65086.7885-.65086.7885-2.14686-.0665-2.96286-1.444-2.96286-1.444 0-3.059 1.39886-5.5385 1.39886-5.5385 1.39886-1.026 2.7297-.9975 2.7297-.9975l.0972.114c-1.74861.494-2.5549 1.2445-2.5549 1.2445s.21371-.114.57314-.2755c1.03943-.4465 1.86515-.57 2.20516-.5985.0583-.0095.1068-.019.1651-.019.5926-.076 1.2629-.095 1.9623-.019.9229.1045 1.9137.3705 2.924.912 0 0-.7674-.7125-2.4188-1.2065l.136-.152s1.3308-.0285 2.7297.9975c0 0 1.3988 2.4795 1.3988 5.5385 0 0-.8257 1.3775-2.9725 1.444z" />
                          </g>
                        </svg>
                      </div>
                      <div className="social_icon w-embed">
                        <svg
                          width={24}
                          height={24}
                          viewBox="0 0 24 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M9.18374 3.49242C6.93651 4.25353 5.07148 5.85373 3.9795 7.95768C3.61066 8.6722 3.34162 9.43383 3.17989 10.2213C2.77617 12.1952 3.05655 14.2474 3.97499 16.0412C4.57897 17.2106 5.4293 18.2356 6.46755 19.0458C7.45634 19.817 8.59236 20.3785 9.80603 20.6959C11.3364 21.0974 12.9649 21.0884 14.5054 20.7444C15.898 20.4297 17.216 19.7767 18.2686 18.8281C19.3717 17.8196 20.1761 16.5278 20.594 15.0937C21.0525 13.5497 21.1124 11.9007 20.8255 10.3138H12.1857V13.826H17.1923C17.0903 14.3896 16.8749 14.9268 16.5591 15.4048C16.2432 15.8829 15.8335 16.292 15.3547 16.6073C14.7412 17.0048 14.0523 17.2716 13.3309 17.3912C12.6057 17.5204 11.8633 17.5188 11.1387 17.3867C10.4054 17.24 9.70974 16.9453 9.09452 16.5205C8.11699 15.8463 7.3803 14.8783 6.99159 13.7572C6.60082 12.6305 6.5963 11.3774 6.99159 10.2552C7.26958 9.45583 7.7252 8.72975 8.32427 8.13137C9.07423 7.37748 10.0279 6.85817 11.0687 6.63694C11.9628 6.45135 12.8889 6.48776 13.7657 6.74296C14.5054 6.96063 15.1876 7.36329 15.7455 7.88436L17.4339 6.22977C17.7298 5.9354 18.0404 5.65004 18.3273 5.34439C17.467 4.56086 16.4624 3.95179 15.3694 3.55107C13.3727 2.83796 11.1937 2.8173 9.18374 3.49242V3.49242Z"
                            fill="currentColor"
                          />
                          <path
                            d="M9.18388 3.49259C11.1936 2.8181 13.3718 2.83677 15.3696 3.5456C16.4651 3.94148 17.468 4.56068 18.3274 5.34005C18.0406 5.64457 17.73 5.92992 17.4341 6.22543L15.7456 7.88002C15.182 7.35251 14.5041 6.96191 13.7647 6.73861C12.8888 6.48087 11.9625 6.44405 11.0688 6.63146C10.1357 6.83536 9.27064 7.2753 8.5567 7.90909C7.84276 8.54287 7.30387 9.34923 6.99173 10.2508C5.9877 9.48611 4.98593 8.72705 3.97852 7.96235C5.0691 5.85589 6.93496 4.2537 9.18388 3.49259V3.49259Z"
                            fill="currentColor"
                          />
                          <path
                            d="M3.18405 10.2172C3.34781 9.43329 3.61322 8.66859 3.98479 7.95239C4.98656 8.71709 5.98833 9.47728 6.99575 10.242C6.60046 11.3687 6.60046 12.6218 6.99575 13.744C5.99398 14.5087 4.99108 15.2734 3.98931 16.0325C3.06258 14.2431 2.77836 12.1905 3.18405 10.2172V10.2172Z"
                            fill="currentColor"
                          />
                          <path
                            d="M12.1853 10.3096H20.8252C21.1193 11.8993 21.04 13.5355 20.5937 15.0895C20.1754 16.5237 19.3706 17.8155 18.2671 18.8239L15.3499 16.6031C15.8285 16.2877 16.238 15.8785 16.5536 15.4005C16.8693 14.9224 17.0845 14.3853 17.1863 13.8218H12.1797C12.1853 12.651 12.1853 11.4803 12.1853 10.3096Z"
                            fill="currentColor"
                          />
                          <path
                            d="M3.97949 16.037C4.98239 15.2779 5.98416 14.5144 6.98593 13.7485C7.37669 14.8688 8.11341 15.8364 9.08999 16.5118C9.70212 16.9325 10.4035 17.2325 11.1342 17.378C11.8547 17.5224 12.6001 17.5032 13.3252 17.3825C14.047 17.2631 14.7364 16.9963 15.3502 16.5987L18.2686 18.8195C17.216 19.7725 15.898 20.421 14.5054 20.7346C12.9649 21.0786 11.3364 21.0887 9.80602 20.6872C8.59159 20.3718 7.45517 19.8102 6.46754 19.0371C5.43099 18.2282 4.58217 17.2047 3.97949 16.037V16.037Z"
                            fill="currentColor"
                          />
                        </svg>
                      </div>
                      <div className="social_icon w-embed">
                        <svg
                          fill="none"
                          height={24}
                          viewBox="0 0 24 24"
                          width={24}
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <g
                            clipRule="evenodd"
                            fill="currentColor"
                            fillRule="evenodd"
                          >
                            <path d="m11.9844 3c-4.73586 0-8.61571 3.64539-8.9844 8.2781l4.83212 1.9944c.40941-.2795.90403-.4429 1.43621-.4429.04764 0 .09509.0012.14214.004l2.14903-3.1094c0-.0148-.0003-.02921-.0003-.04401 0-1.87144 1.5251-3.39417 3.4-3.39417 1.8747 0 3.4001 1.52273 3.4001 3.39417 0 1.87161-1.5254 3.39441-3.4001 3.39441-.0259 0-.0514-.0006-.0771-.0012l-3.0648 2.183c.0016.0399.003.0803.003.1206 0 1.4049-1.1448 2.5477-2.55197 2.5477-1.23536 0-2.26809-.8803-2.50215-2.0458l-3.45581-1.4263c1.07009 3.7778 4.54686 6.5474 8.67403 6.5474 4.9792 0 9.0156-4.0296 9.0156-9 0-4.97057-4.0364-9-9.0156-9z" />
                            <path d="m8.65042 16.6563-1.10745-.4567c.1963.4079.53593.7493.98667.937.97441.4053 2.09806-.0564 2.50436-1.0298.1965-.4712.1978-.9908.0029-1.4629-.1947-.4722-.5622-.8405-1.0343-1.037-.4685-.1946-.97044-.1873-1.41148-.0214l1.14402.4723c.71876.2992 1.05866 1.1231.75916 1.8406-.2993.7176-1.12508 1.057-1.84388.7579z" />
                            <path d="m13.2607 9.6763c0-.93838.7621-1.69876 1.7019-1.69876.94 0 1.7019.76038 1.7019 1.69876 0 .9384-.7619 1.6988-1.7019 1.6988-.9398 0-1.7019-.7604-1.7019-1.6988zm3.9637.00395c0-1.24704-1.0163-2.26179-2.2655-2.26179s-2.2655 1.01475-2.2655 2.26179c0 1.24705 1.0163 2.26135 2.2655 2.26135s2.2655-1.0143 2.2655-2.26135z" />
                          </g>
                        </svg>
                      </div>
                      <div className="social_icon w-embed">
                        <svg
                          width={24}
                          height={24}
                          viewBox="0 0 24 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M4 10C4.39556 10 4.78225 10.1173 5.11115 10.3371C5.44004 10.5568 5.69637 10.8692 5.84775 11.2346C5.99912 11.6001 6.03875 12.0022 5.96158 12.3902C5.88441 12.7781 5.69392 13.1345 5.41422 13.4142C5.13451 13.6939 4.77813 13.8844 4.39017 13.9616C4.00221 14.0387 3.60007 13.9991 3.23462 13.8477C2.86917 13.6964 2.55683 13.44 2.33707 13.1111C2.1173 12.7822 2 12.3956 2 12C2 11.4696 2.21071 10.9609 2.58578 10.5858C2.96086 10.2107 3.46957 10 4 10ZM12 10C12.3956 10 12.7822 10.1173 13.1111 10.3371C13.44 10.5568 13.6964 10.8692 13.8477 11.2346C13.9991 11.6001 14.0387 12.0022 13.9616 12.3902C13.8844 12.7781 13.6939 13.1345 13.4142 13.4142C13.1345 13.6939 12.7781 13.8844 12.3902 13.9616C12.0022 14.0387 11.6001 13.9991 11.2346 13.8477C10.8692 13.6964 10.5568 13.44 10.3371 13.1111C10.1173 12.7822 10 12.3956 10 12C10 11.4696 10.2107 10.9609 10.5858 10.5858C10.9609 10.2107 11.4696 10 12 10ZM20 10C20.3956 10 20.7822 10.1173 21.1111 10.3371C21.44 10.5568 21.6964 10.8692 21.8477 11.2346C21.9991 11.6001 22.0387 12.0022 21.9616 12.3902C21.8844 12.7781 21.6939 13.1345 21.4142 13.4142C21.1345 13.6939 20.7781 13.8844 20.3902 13.9616C20.0022 14.0387 19.6001 13.9991 19.2346 13.8477C18.8692 13.6964 18.5568 13.44 18.3371 13.1111C18.1173 12.7822 18 12.3956 18 12C18 11.4696 18.2107 10.9609 18.5858 10.5858C18.9609 10.2107 19.4696 10 20 10Z"
                            fill="currentColor"
                          />
                        </svg>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="xccz">
                  <div className="x_contentimage">
                    <div className="x_contentimage_tint">
                      <div className="x_temp_tint_1" />
                    </div>
                    <div
                      data-xsb-bg="pic"
                      className="xsb_bg_static xsb_bg_static--xsolla3"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="xccz xccz--rel">
          <div className="x_contentimage">
            <div className="x_contentimage_tint">
              <section
                id="xsbm_login_w1"
                className="x_temp_tint_1 x_temp_tint_1--dark"
              />
            </div>
            <div className="x_contentimage_static">
              <div className="x_temp_pic1" />
            </div>
          </div>
        </div>
      </div>
      <div id="login_w" className="p_x_anchor" />
    </div>
  );
}

export function PAloginSBemail({ editmode = true, children }) {
  return (
    <div id="login_m" className="l_sb0">
      {children}
      {editmode && (
        <div className="x_left0">
          <div className="x_left0_sticky">
            <div className="xx_set_head xx_set_head--main">
              <FormGroup indentation="xs">
                <Head appearance="separated" indentation="xs">
                  Email: <span className="x_login_set_sel">confirmation</span>
                </Head>
              </FormGroup>
            </div>
            <div
              data-xsb-settings-module="onoff"
              data-xsb-settings-module-onoff-activetarget="w_buy"
              className="xx_set_sect"
            >
              <div className="xsb_set_line xsb_set_line--fullsub xsb_set_line--login">
                <div className="l_width100">
                  <div className="xsb_sett_toggle0">
                    <div className="xsb_sett_toggle_b">
                      <div className="xsb_sett_toggle_t" />
                    </div>
                    <div
                      data-xsb-settings-module-onoff="hero_w_logo"
                      className="xsb_sett_toggle_label"
                    >
                      <div>Custom Background</div>
                    </div>
                  </div>
                  <div className="xsb_module_but">
                    <div className="xsb_global_settings_bg xsb_global_settings_bg--2">
                      <div
                        xsb_template_media_control="bg"
                        className="xsb_media"
                      >
                        <div className="xsb_but_upload">
                          <div className="w-embed">
                            <svg
                              width={24}
                              height={24}
                              viewBox="0 0 24 24"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                fillRule="evenodd"
                                clipRule="evenodd"
                                d="M7.5 19C4.46243 19 2 16.5376 2 13.5C2 10.4624 4.46243 8 7.5 8C7.60002 8 7.69941 8.00267 7.79811 8.00794C8.8344 6.21016 10.7759 5 13 5C16.0561 5 18.5785 7.28485 18.9523 10.2395C20.7249 10.8436 22 12.5229 22 14.5C22 16.9853 19.9853 19 17.5 19H14V17.3852H17.9237C19.4108 17.3852 20.6163 16.1797 20.6163 14.6926C20.6163 13.5312 19.874 12.5112 18.793 12.1428C18.0138 11.8773 17.4541 11.1909 17.3508 10.3742C17.0806 8.23775 15.2526 6.61481 13.077 6.61481C11.5177 6.61481 10.106 7.44842 9.34063 8.77615C8.93545 9.47906 8.16968 9.89468 7.35951 9.85141C7.29113 9.84776 7.22239 9.84592 7.15332 9.84592C5.07141 9.84592 3.38369 11.5336 3.38369 13.6156C3.38369 15.6975 5.07141 17.3852 7.15332 17.3852H10V19H7.5ZM8 14L12 10L16 14H13V19C13 19.5523 12.5523 20 12 20C11.4477 20 11 19.5523 11 19V14H8Z"
                                fill="currentColor"
                              />
                            </svg>
                          </div>
                        </div>
                        <div className="xccz">
                          <div className="x_contentimage">
                            <div className="x_contentimage_tint">
                              <div className="x_temp_tint_1 x_temp_tint_1--0" />
                            </div>
                            <div className="x_contentimage_static">
                              <div className="x_temp_pic1" />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              data-xsb-settings-module="onoff"
              data-xsb-settings-module-onoff-activetarget="w_buy"
              className="xx_set_sect"
            >
              <div className="xx_set_head">
                <div className="xx_img_menu_left">
                  <div data-xsb-settings-module-onoff="w_pack1">
                    <div className="xsb_sett_head">Footer social</div>
                  </div>
                </div>
                <div className="xx_img_menu_right">
                  <div className="xx_img_menu_li">
                    <div className="xx_but_menu_icon xx_but_menu_icon--secondary">
                      <div>delete</div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="xx_set_menu xx_set_menu--noborder" />
              <div className="xsb_set_line xsb_set_line--fullsub xsb_set_line--login">
                <div className="xx_set_line" />
                <div className="xx_set_line">
                  <div className="x_flex x_flex--vcenter">
                    <div className="xsb_sett_drag" />
                    <div className="xsb_but_link_input">
                      <div className="social_icon social_icon--sett w-embed">
                        <svg
                          width={39}
                          height={36}
                          viewBox="0 0 39 36"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M19.8 5.40039C12.8412 5.40039 7.19995 11.1759 7.19995 18.3004C7.19995 25.4249 12.8412 31.2004 19.8 31.2004C26.7588 31.2004 32.4001 25.4249 32.4001 18.3004C32.4001 11.1759 26.7588 5.40039 19.8 5.40039ZM20.6293 18.2155V25.0514H17.8358V18.2158H16.4401V15.8601H17.8358V14.4458C17.8358 12.524 18.6238 11.3812 20.8629 11.3812H22.7269V13.7372H21.5618C20.6902 13.7372 20.6325 14.0664 20.6325 14.6808L20.6293 15.8598H22.7401L22.4931 18.2155H20.6293Z"
                            fill="currentColor"
                          />
                        </svg>
                      </div>
                      <div className="xsb_but_seturl_placeholder">
                        <div>Facebook</div>
                      </div>
                      <div className="xx_but_menu_icon xx_but_sett_icon--blue">
                        <div>expand_more</div>
                      </div>
                    </div>
                    <div className="xx_but_menu_icon xx_but_menu_icon--link">
                      <div>insert_link</div>
                    </div>
                  </div>
                </div>
                <div className="xx_set_line">
                  <div className="x_flex x_flex--vcenter">
                    <div className="xsb_sett_drag" />
                    <div className="xsb_but_link_input">
                      <div className="social_icon social_icon--sett w-embed">
                        <svg
                          width={39}
                          height={36}
                          viewBox="0 0 39 36"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M19.2002 5.40039C12.2413 5.40039 6.6001 11.1759 6.6001 18.3004C6.6001 25.4249 12.2413 31.2004 19.2002 31.2004C26.159 31.2004 31.8002 25.4249 31.8002 18.3004C31.8002 11.1759 26.159 5.40039 19.2002 5.40039ZM16.4299 11.4615C17.1467 11.4281 17.3758 11.4199 19.2008 11.4199H19.1987C21.0244 11.4199 21.2526 11.4281 21.9694 11.4615C22.6848 11.495 23.1734 11.611 23.6018 11.7811C24.0442 11.9567 24.418 12.1918 24.7918 12.5745C25.1656 12.9569 25.3952 13.3408 25.5674 13.7933C25.7326 14.2307 25.846 14.7307 25.8796 15.4631C25.9118 16.197 25.9202 16.4315 25.9202 18.3C25.9202 20.1685 25.9118 20.4024 25.8796 21.1363C25.846 21.8685 25.7326 22.3685 25.5674 22.8061C25.3952 23.2585 25.1656 23.6424 24.7918 24.0248C24.4184 24.4075 24.0441 24.6431 23.6022 24.8189C23.1747 24.989 22.6858 25.1049 21.9704 25.1385C21.2535 25.1719 21.0252 25.1801 19.2 25.1801C17.3751 25.1801 17.1462 25.1719 16.4294 25.1385C15.7141 25.1049 15.2256 24.989 14.7981 24.8189C14.3563 24.6431 13.9814 24.4075 13.608 24.0248C13.2344 23.6424 13.0048 23.2585 12.833 22.806C12.6669 22.3685 12.5537 21.8686 12.5208 21.1362C12.4883 20.4023 12.4802 20.1685 12.4802 18.3C12.4802 16.4315 12.4886 16.1968 12.5206 15.463C12.5528 14.7308 12.6662 14.2307 12.8328 13.7931C13.005 13.3408 13.2346 12.9569 13.6085 12.5745C13.982 12.1919 14.3569 11.9569 14.7989 11.7811C15.2262 11.611 15.7145 11.495 16.4299 11.4615Z"
                            fill="currentColor"
                          />
                          <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M18.5979 12.613C18.7149 12.6129 18.8409 12.6129 18.9768 12.613L19.2007 12.613C20.995 12.613 21.2077 12.6196 21.9162 12.6523C22.5714 12.6828 22.927 12.7942 23.1639 12.8877C23.4775 13.0116 23.7011 13.1597 23.9362 13.3989C24.1714 13.6382 24.317 13.866 24.4391 14.185C24.531 14.4256 24.6407 14.7873 24.6705 15.4538C24.7027 16.1743 24.7097 16.3907 24.7097 18.2149C24.7097 20.039 24.7027 20.2554 24.6705 20.976C24.6405 21.6424 24.531 22.0041 24.4391 22.2448C24.3172 22.5637 24.1714 22.7909 23.9362 23.0299C23.701 23.2692 23.4777 23.4173 23.1639 23.5412C22.9273 23.6351 22.5714 23.7462 21.9162 23.7767C21.2078 23.8094 20.995 23.8166 19.2007 23.8166C17.4063 23.8166 17.1937 23.8094 16.4853 23.7767C15.83 23.7459 15.4744 23.6346 15.2374 23.541C14.9238 23.4171 14.6998 23.269 14.4646 23.0298C14.2294 22.7906 14.0838 22.5633 13.9617 22.2442C13.8697 22.0035 13.7601 21.6418 13.7303 20.9754C13.6981 20.2549 13.6917 20.0384 13.6917 18.2132C13.6917 16.3879 13.6981 16.1726 13.7303 15.452C13.7603 14.7856 13.8697 14.4239 13.9617 14.183C14.0835 13.864 14.2294 13.6362 14.4646 13.3969C14.6998 13.1577 14.9238 13.0096 15.2374 12.8854C15.4743 12.7915 15.83 12.6804 16.4853 12.6498C17.1052 12.6213 17.3454 12.6128 18.5979 12.6113V12.613ZM22.7879 13.7487C22.3427 13.7487 21.9814 14.1157 21.9814 14.5687C21.9814 15.0215 22.3427 15.3889 22.7879 15.3889C23.2331 15.3889 23.5943 15.0215 23.5943 14.5687C23.5943 14.1158 23.2331 13.7484 22.7879 13.7484V13.7487ZM15.7499 18.2172C15.7499 16.2787 17.295 14.7071 19.2008 14.707C21.1066 14.707 22.6514 16.2787 22.6514 18.2172C22.6514 20.1556 21.1068 21.7266 19.2009 21.7266C17.2951 21.7266 15.7499 20.1556 15.7499 18.2172Z"
                            fill="currentColor"
                          />
                          <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M19.2007 15.9375C20.4378 15.9375 21.4408 16.9575 21.4408 18.2159C21.4408 19.4741 20.4378 20.4943 19.2007 20.4943C17.9635 20.4943 16.9607 19.4741 16.9607 18.2159C16.9607 16.9575 17.9635 15.9375 19.2007 15.9375V15.9375Z"
                            fill="currentColor"
                          />
                        </svg>
                      </div>
                      <div className="xsb_but_seturl_placeholder">
                        <div className="text-block-19">Instagram</div>
                      </div>
                      <div className="xx_but_menu_icon xx_but_sett_icon--blue">
                        <div>expand_more</div>
                      </div>
                    </div>
                    <div className="xx_but_menu_icon xx_but_menu_icon--link">
                      <div>insert_link</div>
                    </div>
                  </div>
                </div>
                <div className="xx_set_line">
                  <div className="x_flex x_flex--vcenter">
                    <div className="xsb_sett_drag" />
                    <div className="xsb_but_link_input">
                      <div className="social_icon social_icon--sett w-embed">
                        <svg
                          width={39}
                          height={36}
                          viewBox="0 0 39 36"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M7.19995 18.3004C7.19995 11.1759 12.8412 5.40039 19.8 5.40039C26.7588 5.40039 32.4001 11.1759 32.4001 18.3004C32.4001 25.4249 26.7588 31.2004 19.8 31.2004C12.8412 31.2004 7.19995 25.4249 7.19995 18.3004ZM26.4133 19.1647L24.0196 21.6062H20.2596L18.2083 23.6983V21.6062H15.1316V11.4931H26.4133V19.1647ZM13.7636 10.0983L13.08 12.8882V25.4419H16.1571V27.1859H17.8659L19.5758 25.4419H22.3103L27.78 19.8631V10.0983H13.7636ZM20.2595 18.4684H18.892V14.283H20.2595V18.4684ZM24.0197 18.4684H22.6523V14.283H24.0197V18.4684Z"
                            fill="currentColor"
                          />
                        </svg>
                      </div>
                      <div className="xsb_but_seturl_placeholder">
                        <div className="text-block-19">Twitch</div>
                      </div>
                      <div className="xx_but_menu_icon xx_but_sett_icon--blue">
                        <div>expand_more</div>
                      </div>
                    </div>
                    <div className="xx_but_menu_icon xx_but_menu_icon--link">
                      <div>insert_link</div>
                    </div>
                  </div>
                </div>
                <div className="xx_set_line">
                  <div className="x_flex x_flex--vcenter">
                    <div className="xsb_sett_drag" />
                    <div className="xsb_but_link_input">
                      <div className="social_icon social_icon--sett w-embed">
                        <svg
                          width={39}
                          height={36}
                          viewBox="0 0 39 36"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M19.7999 5.40039C12.8412 5.40039 7.19995 11.1759 7.19995 18.3004C7.19995 25.4249 12.8412 31.2004 19.7999 31.2004C26.7587 31.2004 32.3999 25.4249 32.3999 18.3004C32.3999 11.1759 26.7587 5.40039 19.7999 5.40039ZM25.9923 14.0666C26.6201 13.9895 27.2186 13.817 27.7745 13.5618C27.3598 14.2052 26.8332 14.7697 26.2267 15.2222C26.2321 15.359 26.2347 15.4985 26.2347 15.638C26.2347 19.8777 23.1135 24.7653 17.4038 24.7653C15.6518 24.7653 14.0197 24.2339 12.646 23.3252C12.8884 23.3546 13.1362 23.3693 13.3866 23.3693C14.8402 23.3693 16.1793 22.8562 17.2413 21.9952C15.8827 21.9704 14.7372 21.0425 14.342 19.7685C14.5312 19.8061 14.7265 19.8254 14.9263 19.8254C15.2096 19.8254 15.484 19.7877 15.7442 19.7125C14.3234 19.4187 13.2534 18.1218 13.2534 16.5669V16.5275C13.6725 16.7661 14.152 16.912 14.6599 16.9276C13.827 16.3521 13.2791 15.37 13.2791 14.2576C13.2791 13.6701 13.4319 13.1185 13.6991 12.643C15.2309 14.5862 17.5174 15.862 20.097 15.996C20.0437 15.761 20.0171 15.5169 20.0171 15.2654C20.0171 13.4939 21.4068 12.0574 23.1197 12.0574C24.013 12.0574 24.8202 12.4466 25.3849 13.0698C26.0935 12.9266 26.7569 12.6595 27.3571 12.2924C27.1254 13.0414 26.6334 13.6701 25.9923 14.0666Z"
                            fill="currentColor"
                          />
                        </svg>
                      </div>
                      <div className="xsb_but_seturl_placeholder">
                        <div className="text-block-19">Twitter</div>
                      </div>
                      <div className="xx_but_menu_icon xx_but_sett_icon--blue">
                        <div>expand_more</div>
                      </div>
                    </div>
                    <div className="xx_but_menu_icon xx_but_menu_icon--link">
                      <div>insert_link</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              data-xsb-settings-module="onoff"
              data-xsb-settings-module-onoff-activetarget="w_buy"
              className="xx_set_sect_info0"
            >
              <div>You can use the following variables:</div>
              <ul className="xx_set_sect_info_ul w-list-unstyled">
                <li className="xx_set_sect_info_li">
                  <div className="l_flex">
                    {"{"}$project_name{"}"}
                  </div>
                </li>
                <li className="xx_set_sect_info_li">
                  <div>
                    {"{"}$charge_amount_invoice{"}"}{" "}
                  </div>
                </li>
                <li className="xx_set_sect_info_li">
                  <div>
                    {"{"}$currency_invoice{"}"}{" "}
                  </div>
                </li>
                <li className="xx_set_sect_info_li">
                  <div>
                    {"{"}$date_charge{"}"}
                  </div>
                </li>
                <li className="xx_set_sect_info_li">
                  <div>
                    {"{"}$company_name{"}"}
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      )}

      <div className="x_right0">
        <div className="xsb_mail">
          <div id="login_m1" className="l_width100">
            <div className="x_right0">
              <div className="xsb_cont_tabs">
                <div>
                  <div className="x_flex x_flex--center x_flex--vcenter">
                    <div className="p_button p_button--appearance-flatten">
                      <div>Confirmation</div>
                    </div>
                    <div className="p_x_card_filter_div" />
                    <div className="p_button p_button--appearance-flatten inactive">
                      <div>Forgot password</div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="xsbm_mailbg0">
                <div className="xsbm_mailbg_lr" />
                <div>
                  <div className="x_paddings xsb_paddings--mail">
                    <div className="xsbm_mail">
                      <div className="xsbm_mail_w">
                        <div className="xsbm_mailbody">
                          <div className="xsbm_top">
                            <div className="xccz">
                              <div className="x_contentimage">
                                <div className="x_contentimage_tint">
                                  <div className="x_temp_tint_1 x_temp_tint_1--0" />
                                </div>
                                <div className="x_contentimage_static">
                                  <div className="x_temp_pic1" />
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="xsbm_content">
                            <div className="xsbm_cont">
                              <div className="p_formgroup_sm8">
                                <div className="t_h2 t_bold">
                                  <div>Hello!</div>
                                </div>
                              </div>
                              <p
                                data-xsb-template-content="mail_trans_1"
                                className="xsbm_p"
                              >
                                <strong>
                                  Please confirm your new account by clicking
                                  the button below
                                </strong>
                                <br />
                              </p>
                              <div className="xsbm_p xsbm_p--center">
                                <div className="button_primary x_radius">
                                  <div>Confirm account</div>
                                </div>
                              </div>
                            </div>
                            <div className="xbm_accentbg xbm_accentbg--text" />
                          </div>
                          <div className="xsbm_content">
                            <div className="xsbm_check">
                              <div className="xbm_accentbg xbm_accentbg--check" />
                            </div>
                          </div>
                        </div>
                        <div className="xsbm_footer">
                          <div className="xsbm_footer_comp">
                            <p>
                              Copyright © 2018 Human Head Studios, All rights
                              reserved.
                              <br />
                              Thanks for signing up for Rune: Ragnarok exclusive
                              updates and information.
                              <br />
                              <br />
                              Our mailing address is:
                              <br />
                              Human Head Studios 1741 Commercial Ave
                              <br />
                              Madison, Wi 53704
                            </p>
                            <div
                              data-xsb-template-media="companyLogo"
                              className="xsbm_footer_companylogo"
                            />
                            <div className="xsbm_footer_social">
                              <div className="x_sos_h_soc">
                                <div
                                  data-xsb-template-onoff="social_facebook"
                                  className="xsb_foooter_soc xsbm_soc_ico"
                                >
                                  <div className="w-embed">
                                    <svg
                                      width={39}
                                      height={36}
                                      viewBox="0 0 39 36"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <path
                                        fillRule="evenodd"
                                        clipRule="evenodd"
                                        d="M19.8 5.40039C12.8412 5.40039 7.19995 11.1759 7.19995 18.3004C7.19995 25.4249 12.8412 31.2004 19.8 31.2004C26.7588 31.2004 32.4001 25.4249 32.4001 18.3004C32.4001 11.1759 26.7588 5.40039 19.8 5.40039ZM20.6293 18.2155V25.0514H17.8358V18.2158H16.4401V15.8601H17.8358V14.4458C17.8358 12.524 18.6238 11.3812 20.8629 11.3812H22.7269V13.7372H21.5618C20.6902 13.7372 20.6325 14.0664 20.6325 14.6808L20.6293 15.8598H22.7401L22.4931 18.2155H20.6293Z"
                                        fill="currentColor"
                                      />
                                    </svg>
                                  </div>
                                </div>
                                <div
                                  data-xsb-template-onoff="social_facebook"
                                  className="xsb_foooter_soc xsbm_soc_ico"
                                >
                                  <div className="w-embed">
                                    <svg
                                      width={39}
                                      height={36}
                                      viewBox="0 0 39 36"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <path
                                        fillRule="evenodd"
                                        clipRule="evenodd"
                                        d="M19.2002 5.40039C12.2413 5.40039 6.6001 11.1759 6.6001 18.3004C6.6001 25.4249 12.2413 31.2004 19.2002 31.2004C26.159 31.2004 31.8002 25.4249 31.8002 18.3004C31.8002 11.1759 26.159 5.40039 19.2002 5.40039ZM16.4299 11.4615C17.1467 11.4281 17.3758 11.4199 19.2008 11.4199H19.1987C21.0244 11.4199 21.2526 11.4281 21.9694 11.4615C22.6848 11.495 23.1734 11.611 23.6018 11.7811C24.0442 11.9567 24.418 12.1918 24.7918 12.5745C25.1656 12.9569 25.3952 13.3408 25.5674 13.7933C25.7326 14.2307 25.846 14.7307 25.8796 15.4631C25.9118 16.197 25.9202 16.4315 25.9202 18.3C25.9202 20.1685 25.9118 20.4024 25.8796 21.1363C25.846 21.8685 25.7326 22.3685 25.5674 22.8061C25.3952 23.2585 25.1656 23.6424 24.7918 24.0248C24.4184 24.4075 24.0441 24.6431 23.6022 24.8189C23.1747 24.989 22.6858 25.1049 21.9704 25.1385C21.2535 25.1719 21.0252 25.1801 19.2 25.1801C17.3751 25.1801 17.1462 25.1719 16.4294 25.1385C15.7141 25.1049 15.2256 24.989 14.7981 24.8189C14.3563 24.6431 13.9814 24.4075 13.608 24.0248C13.2344 23.6424 13.0048 23.2585 12.833 22.806C12.6669 22.3685 12.5537 21.8686 12.5208 21.1362C12.4883 20.4023 12.4802 20.1685 12.4802 18.3C12.4802 16.4315 12.4886 16.1968 12.5206 15.463C12.5528 14.7308 12.6662 14.2307 12.8328 13.7931C13.005 13.3408 13.2346 12.9569 13.6085 12.5745C13.982 12.1919 14.3569 11.9569 14.7989 11.7811C15.2262 11.611 15.7145 11.495 16.4299 11.4615Z"
                                        fill="currentColor"
                                      />
                                      <path
                                        fillRule="evenodd"
                                        clipRule="evenodd"
                                        d="M18.5979 12.613C18.7149 12.6129 18.8409 12.6129 18.9768 12.613L19.2007 12.613C20.995 12.613 21.2077 12.6196 21.9162 12.6523C22.5714 12.6828 22.927 12.7942 23.1639 12.8877C23.4775 13.0116 23.7011 13.1597 23.9362 13.3989C24.1714 13.6382 24.317 13.866 24.4391 14.185C24.531 14.4256 24.6407 14.7873 24.6705 15.4538C24.7027 16.1743 24.7097 16.3907 24.7097 18.2149C24.7097 20.039 24.7027 20.2554 24.6705 20.976C24.6405 21.6424 24.531 22.0041 24.4391 22.2448C24.3172 22.5637 24.1714 22.7909 23.9362 23.0299C23.701 23.2692 23.4777 23.4173 23.1639 23.5412C22.9273 23.6351 22.5714 23.7462 21.9162 23.7767C21.2078 23.8094 20.995 23.8166 19.2007 23.8166C17.4063 23.8166 17.1937 23.8094 16.4853 23.7767C15.83 23.7459 15.4744 23.6346 15.2374 23.541C14.9238 23.4171 14.6998 23.269 14.4646 23.0298C14.2294 22.7906 14.0838 22.5633 13.9617 22.2442C13.8697 22.0035 13.7601 21.6418 13.7303 20.9754C13.6981 20.2549 13.6917 20.0384 13.6917 18.2132C13.6917 16.3879 13.6981 16.1726 13.7303 15.452C13.7603 14.7856 13.8697 14.4239 13.9617 14.183C14.0835 13.864 14.2294 13.6362 14.4646 13.3969C14.6998 13.1577 14.9238 13.0096 15.2374 12.8854C15.4743 12.7915 15.83 12.6804 16.4853 12.6498C17.1052 12.6213 17.3454 12.6128 18.5979 12.6113V12.613ZM22.7879 13.7487C22.3427 13.7487 21.9814 14.1157 21.9814 14.5687C21.9814 15.0215 22.3427 15.3889 22.7879 15.3889C23.2331 15.3889 23.5943 15.0215 23.5943 14.5687C23.5943 14.1158 23.2331 13.7484 22.7879 13.7484V13.7487ZM15.7499 18.2172C15.7499 16.2787 17.295 14.7071 19.2008 14.707C21.1066 14.707 22.6514 16.2787 22.6514 18.2172C22.6514 20.1556 21.1068 21.7266 19.2009 21.7266C17.2951 21.7266 15.7499 20.1556 15.7499 18.2172Z"
                                        fill="currentColor"
                                      />
                                      <path
                                        fillRule="evenodd"
                                        clipRule="evenodd"
                                        d="M19.2007 15.9375C20.4378 15.9375 21.4408 16.9575 21.4408 18.2159C21.4408 19.4741 20.4378 20.4943 19.2007 20.4943C17.9635 20.4943 16.9607 19.4741 16.9607 18.2159C16.9607 16.9575 17.9635 15.9375 19.2007 15.9375V15.9375Z"
                                        fill="currentColor"
                                      />
                                    </svg>
                                  </div>
                                </div>
                                <div
                                  data-xsb-template-onoff="social_facebook"
                                  className="xsb_foooter_soc xsbm_soc_ico"
                                >
                                  <div className="w-embed">
                                    <svg
                                      width={39}
                                      height={36}
                                      viewBox="0 0 39 36"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <path
                                        fillRule="evenodd"
                                        clipRule="evenodd"
                                        d="M7.19995 18.3004C7.19995 11.1759 12.8412 5.40039 19.8 5.40039C26.7588 5.40039 32.4001 11.1759 32.4001 18.3004C32.4001 25.4249 26.7588 31.2004 19.8 31.2004C12.8412 31.2004 7.19995 25.4249 7.19995 18.3004ZM26.4133 19.1647L24.0196 21.6062H20.2596L18.2083 23.6983V21.6062H15.1316V11.4931H26.4133V19.1647ZM13.7636 10.0983L13.08 12.8882V25.4419H16.1571V27.1859H17.8659L19.5758 25.4419H22.3103L27.78 19.8631V10.0983H13.7636ZM20.2595 18.4684H18.892V14.283H20.2595V18.4684ZM24.0197 18.4684H22.6523V14.283H24.0197V18.4684Z"
                                        fill="currentColor"
                                      />
                                    </svg>
                                  </div>
                                </div>
                                <div
                                  data-xsb-template-onoff="social_facebook"
                                  className="xsb_foooter_soc xsbm_soc_ico"
                                >
                                  <div className="w-embed">
                                    <svg
                                      width={39}
                                      height={36}
                                      viewBox="0 0 39 36"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <path
                                        fillRule="evenodd"
                                        clipRule="evenodd"
                                        d="M19.7999 5.40039C12.8412 5.40039 7.19995 11.1759 7.19995 18.3004C7.19995 25.4249 12.8412 31.2004 19.7999 31.2004C26.7587 31.2004 32.3999 25.4249 32.3999 18.3004C32.3999 11.1759 26.7587 5.40039 19.7999 5.40039ZM25.9923 14.0666C26.6201 13.9895 27.2186 13.817 27.7745 13.5618C27.3598 14.2052 26.8332 14.7697 26.2267 15.2222C26.2321 15.359 26.2347 15.4985 26.2347 15.638C26.2347 19.8777 23.1135 24.7653 17.4038 24.7653C15.6518 24.7653 14.0197 24.2339 12.646 23.3252C12.8884 23.3546 13.1362 23.3693 13.3866 23.3693C14.8402 23.3693 16.1793 22.8562 17.2413 21.9952C15.8827 21.9704 14.7372 21.0425 14.342 19.7685C14.5312 19.8061 14.7265 19.8254 14.9263 19.8254C15.2096 19.8254 15.484 19.7877 15.7442 19.7125C14.3234 19.4187 13.2534 18.1218 13.2534 16.5669V16.5275C13.6725 16.7661 14.152 16.912 14.6599 16.9276C13.827 16.3521 13.2791 15.37 13.2791 14.2576C13.2791 13.6701 13.4319 13.1185 13.6991 12.643C15.2309 14.5862 17.5174 15.862 20.097 15.996C20.0437 15.761 20.0171 15.5169 20.0171 15.2654C20.0171 13.4939 21.4068 12.0574 23.1197 12.0574C24.013 12.0574 24.8202 12.4466 25.3849 13.0698C26.0935 12.9266 26.7569 12.6595 27.3571 12.2924C27.1254 13.0414 26.6334 13.6701 25.9923 14.0666Z"
                                        fill="currentColor"
                                      />
                                    </svg>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="xbm_accentbg xbm_accentbg--top">
                            <div
                              data-xsb-template-onoff="w_social"
                              className="c_block"
                            >
                              <div className="c_foot_block _50" />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="xsbm_mail_xsolla">
                        <div>
                          Xsolla is an authorized global distributor of Rune
                          Ragnarock. <br />© Xsolla 2018, All rights reserved.
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="xsb_bgz xsb_bgz--black" />
                </div>
                <div className="xsbm_mailbg_lr" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div id="login_mail" className="p_x_anchor" />
    </div>
  );
}
